import script from "./StatsAvgModeDistanceCommuted.vue?vue&type=script&lang=js"
export * from "./StatsAvgModeDistanceCommuted.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__